export default "__VITE_ASSET__DhaMLWRV__"